module.exports = __webpack_public_path__ + "img/3.cd5fa1fb.jpg";